import { IRootState } from './index'
import { Store, MutationPayload } from 'vuex'

const localStorage = (store: Store<IRootState>) => {
  if (window.localStorage) {
    store.subscribe((mutation: MutationPayload, { cart,
      debug, oCode, offlineMode, profile, theme }: IRootState) => {
      window.localStorage.setItem('rodenstock', JSON.stringify({ cart, debug, oCode, offlineMode, profile, theme }))
    })
  }
}

const plugins = [
  localStorage
]

export default plugins
